import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const XeroPage = lazy(() => import('src/pages/xero/integrations'));
const XeroCreatePage = lazy(() => import('src/pages/xero/integrationsCreate'));
const XeroCoaPage = lazy(() => import('src/pages/xero/coa'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const xeroRoutes = [
  {
    path: 'xero',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <XeroPage />, index: true },
      { path: 'integrations', element: <XeroPage /> },
      { path: 'integrations/create', element: <XeroCreatePage /> },
      { path: 'coa/:id', element: <XeroCoaPage /> },
    ],
  },
];
